import { useEffect, useState } from "react";
import { IParagraphReferredImprove } from './useInformativeLayerParagraph.d'
import { statusReferredType } from "../InformativeLayer.d";
import React from "react";

const paragraphReferred: IParagraphReferredImprove = {
  loading: { text: 'Esto puede demorar unos instantes', },
  exit: { text: 'Recibimos tu solicitud con éxito. Nos comunicaremos telefónicamente con vos para mejorar el plan de tu empresa.', },
  noExit: { text: 'Te llamaremos a la brevedad para potenciar a tu empresa con un plan mejorado.', },
  error: { text: 'Estamos trabajando para solucionarlo, volvé a intentar más tarde.', },
  expired: {
    text: (
      <>
        Solicitá una mejora a través de la opción <strong>Mejorar plan</strong> de nuestro <strong>formulario de contacto</strong> y potenciá a tu empresa.
      </>
    ),
  },
  limitExceeded: { text: 'Superaste el máximo de referidos por día. Volvé a referir mañana.', },
}


export default function useInformativeParagraph(status: statusReferredType): string | JSX.Element {
  const [paragraph, setParagraph] = useState<string | JSX.Element>(paragraphReferred.loading.text);

  useEffect(() => {
    switch (status) {
      case 'EXIT':
        setParagraph(paragraphReferred.exit.text)
        break
      case 'NOT_EXIT':
        setParagraph(paragraphReferred.noExit.text)
        break
      case 'ERROR':
        setParagraph(paragraphReferred.error.text)
        break
      case 'EXPIRED':
        setParagraph(paragraphReferred.expired.text)
        break
      case 'LIMIT_EXCEEDED':
        setParagraph(paragraphReferred.limitExceeded.text)
        break
      default:
        setParagraph(paragraphReferred.loading.text)
    }
  }, [status])

  return paragraph
}
